<template>
  <a-select
    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
    v-model:value="year"
    placeholder="----"
    :options="yearsOptions"
  >
    <template #suffixIcon>
      <CalendarOutlined />
    </template>
  </a-select>
</template>

<script setup>
import { computed } from "vue";
import { CalendarOutlined } from "@ant-design/icons-vue";

import { createSameValueAndLabelOptions } from "@/app/shared/utils/helpers";

const emit = defineEmits(["update:value"]);

const props = defineProps({
  value: Number,
});

const BASE_YEAR = 2010;
const currentYear = new Date().getFullYear();
const options = [];

for (let i = currentYear; i >= BASE_YEAR; i--) {
  options.push(i);
}

const yearsOptions = computed(() => createSameValueAndLabelOptions({ options, stringValue: true }));

const year = computed({
  get() {
    return props.value;
  },

  set(newValue) {
    emit("update:value", newValue);
  },
});
</script>

<style lang="sass" scoped></style>
